import React from 'react';
import { connect } from 'react-redux';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';

function Covid19StateCommunication(props) {
  return <ContentPage {...props} />;
}

export async function getStaticProps() {
  return { props: { sitepageid: 410 } };
}

export default connect(mapStateToProps)(withMembershipAccessWrap(Covid19StateCommunication));
